import AllOperationComponent from "../components/all-operation.component";

export default function AllOperationPage() {
  return (
    <div>
      <AllOperationComponent />
    </div>
  );
}
